import React from "react";
import { Provider } from "react-redux";
import NavContainer from "app/navigation/nav-container/nav-container";
import { Provider as PaperProvider } from "react-native-paper";
import { DarkTheme, LightTheme } from "app/shared/styles";
import store from "app/shared/store/store";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { Platform } from "react-native";
import analyticConfig from "app/shared/util/analytic";
import i18n from "app/shared/language/i18n";
import { FontDisplay, useFonts } from "expo-font";
import ModalContainer from "app/modules/modal-management/modals/modal-container";

export default function App() {
  const [fontsLoaded] = useFonts({
    "Montserrat-Bold": { uri: require("./assets/fonts/Montserrat-Bold.ttf"), display: FontDisplay.SWAP },
    "Montserrat-SemiBold": { uri: require("./assets/fonts/Montserrat-SemiBold.ttf"), display: FontDisplay.SWAP },
    "Montserrat-Medium": { uri: require("./assets/fonts/Montserrat-Medium.ttf"), display: FontDisplay.SWAP },
    Montserrat: { uri: require("./assets/fonts/Montserrat-Regular.ttf"), display: FontDisplay.SWAP },
    "Card-Fonts": { uri: require("./assets/fonts/Card.ttf"), display: FontDisplay.SWAP },
  });

  const [isThemeDark] = React.useState(false);

  let theme = isThemeDark ? DarkTheme : LightTheme;

  React.useEffect(() => {
    i18n.init();
    if (Platform.OS === "web" && !__DEV__) {
      analyticConfig();
    }
  }, []);

  if (!fontsLoaded) {
    return null;
  } else {
    return (
      <Provider store={store}>
        <SafeAreaProvider>
          <PaperProvider theme={theme}>
            <NavContainer />
            <ModalContainer />
          </PaperProvider>
        </SafeAreaProvider>
      </Provider>
    );
  }
}
